// extracted by mini-css-extract-plugin
module.exports = {"coverLink":"Hb-z","contentBox":"Ib-z","zapposPromoContainer":"Jb-z","zapposPromoGroupContainer":"Kb-z","promos":"Lb-z","bottom":"Mb-z","top":"Nb-z","right":"Ob-z","left":"Pb-z"};